import get from'../object/get.js';const notFound = Symbol("notFound");
/**
 * Count data by the given key or callback
 */
function count(data, key) {
    if (!Array.isArray(data))
        return 0;
    if (typeof key === "string") {
        return data.filter(item => get(item, key, notFound) !== notFound)
            .length;
    }
    return data.filter(key).length;
}export{count as default};